import type {
    CarReportApi,
    CarReportAssigneeHistoryApi,
    CarReportAssigneeHistoryUI,
    CarReportRemarkApi,
    CarReportRemarkUI,
    CarReportStatusChangeApi,
    CarReportStatusChangeUI,
    ICarReport,
} from './carReport.types';

import { toDisplayStatus } from '../config/carReportStatus';
import { formatUtcDisplay, formatUtcToDDMMMYYYY, toUtcMs } from '../utils/dateTime';

const formatToYesNo = (v?: boolean) => (v === true ? 'Yes' : v === false ? 'No' : '--');

export const mapCarReportApiToUI = (api: CarReportApi): ICarReport => {
    const createdAt = api.createdAt;
    const closedAt = api.closedAt;

    const rawStatus = String(api.status ?? '').trim();

    return {
        id: api.id ? String(api.id) : undefined,
        ufi: api.ufi,

        category: api.category,
        subject: api.subject,
        comment: api.comments,
        creator: api.creator,

        creationTime: formatUtcDisplay(createdAt),
        creationTimeUtc: toUtcMs(createdAt),

        closedAt: closedAt ? formatUtcDisplay(closedAt) : undefined,
        closedAtUtc: toUtcMs(closedAt),

        rawStatus: rawStatus || undefined,
        status: toDisplayStatus(rawStatus),

        assigneeLead: api.assigneeLead,
        assigneeGroup: Array.isArray(api.assigneeGroup) ? api.assigneeGroup : [],

        airport: api.airport,
        chartRef: api.chartRef,

        isResponseRequiredText: formatToYesNo(api.isResponseRequired),

        photoIDs: Array.isArray(api.photoIDs) ? api.photoIDs : [],
        photos: Array.isArray(api.photos) ? api.photos : [],
    };
};

export const mapRemarkApiToUI = (api: CarReportRemarkApi): CarReportRemarkUI => {
    const changedAtDisplay = formatUtcDisplay(api.changedAt);
    return {
        changedBy: String(api.changedBy ?? '--'),
        content: String(api.content ?? '--'),
        changedAtUtc: toUtcMs(api.changedAt),
        changedAtDisplay,
        attachment: Array.isArray(api.attachment) ? api.attachment : [],
    };
};

export const mapStatusChangeApiToUI = (api: CarReportStatusChangeApi): CarReportStatusChangeUI => {
    const statusRaw = String(api.status ?? '').trim();
    return {
        statusRaw,
        statusDisplay: toDisplayStatus(statusRaw),
        changedBy: String(api.changedBy ?? '--'),
        changedAtUtc: toUtcMs(api.changedAt),
        changedAtDisplay: formatUtcToDDMMMYYYY(api.changedAt),
    };
};

export const mapAssigneeHistoryApiToUI = (api: CarReportAssigneeHistoryApi): CarReportAssigneeHistoryUI => {
    const groupText =
        Array.isArray(api.assigneeGroup) && api.assigneeGroup.length > 0 ? api.assigneeGroup.join(', ') : '';

    const leadText = (api.assigneeLead ?? '').trim();
    const groupOrLead = groupText || leadText || '--';

    return {
        assigneeGroup: groupOrLead,
        assigneeLead: leadText,
        assignedBy: String(api.changedBy ?? '--'),
        assignTimeUtc: toUtcMs(api.changedAt),
        assignTime: formatUtcToDDMMMYYYY(api.changedAt),
    };
};

export const mapOriginalSubmissionApiToUI = (v: any) => v; // TBC
